import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import { cn } from "@/lib/utils";

interface StaffingModalProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title: string;
    children: React.ReactNode;
    wide?: boolean;
}

const StaffingModal = ({ open, onOpenChange, title, children, wide }: StaffingModalProps) => (
    <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className={cn(wide && "w-[80vw] max-w-none")}>
            <DialogHeader>
                <DialogTitle>{title}</DialogTitle>
            </DialogHeader>
            <div className="overflow-y-auto max-h-[calc(80vh-4rem)]">
                {children}
            </div>
        </DialogContent>
    </Dialog>
);

export default StaffingModal;
